import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {CardContent, Typography, Card, ListItemText, ListItem, List, Fade, Backdrop, Modal, Paper, TableRow, TableHead, TableCell, TableBody, Table} from '@material-ui/core';


const styles = theme => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        // minWidth: 700,
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    card:{
        maxHeight: '500px',
        overflow:'auto',
        padding: '0px',
    },
    cardHeader:{
        margin:'8px 16px'
    },
    list:{
        width:500,
        height:500
    }
});

const CanvasUserTable = (props) => {
    const [open, setOpen] = useState(false);
    const [selectedUnid, setSelectedUnid] = useState('');
    const [departments, setDepartments] = useState([]);

    const handleOpen = (unid) => {
        if(props.addType=='newUser'){
            setDepartments(props.departments);
            setOpen(true);
            setSelectedUnid(unid);
        }else{
            const selectedDepartments = null;
            props.onUserSelection(unid);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const renderRow = (user) => {
        if (props.hideRemove) {
            return (
                <TableRow key={user.unid}>
                    <TableCell>{user.display_name}</TableCell>
                    <TableCell>{user.unid}</TableCell>
                </TableRow>
            )
        } else {
            return (
                <TableRow key={user.unid}>
                    <TableCell>{user.display_name}</TableCell>
                    <TableCell>{user.unid}</TableCell>
                    <TableCell>
                        <div onClick={()=>handleOpen(user.unid)}>
                            {props.children}
                        </div>
                    </TableCell>
                </TableRow>
            )
        }

    };

    const renderList = (department, index) => {
        return(
            <ListItem key = {index} button onClick = {()=>handleDepartmentSelect(department)}>
                <ListItemText primary={department} />
            </ListItem>
        )
    }

    const handleDepartmentSelect = function(department){
        const selectedDepartments = [department];
        props.onUserSelection(selectedUnid, selectedDepartments);
        setOpen(false);
    }

    const renderDepartmentModal = function(){
        if(props.addType=='newUser'){
            return(
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={props.classes.modal}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <Card >
                            <Typography className={props.classes.cardHeader} variant="h5" component="h2">
                                Select User Department
                            </Typography>
                            <CardContent className = {props.classes.card}>
                                <List>
                                    {departmentList}
                                </List>
                            </CardContent>
                        </Card>
                    </Fade>
                </Modal>
            )
        }else{
            return;
        }

    }

    const rows = props.users.map((user) => renderRow(user));
    const departmentList = departments.map((department,index) => renderList(department, index));

    if (props.hideRemove) {
        return (
            <Paper className={props.classes.root}>
                <Table className={props.classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>uNID</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows}
                    </TableBody>
                </Table>
            </Paper>
        )
    } else {
        return (
            <Paper className={props.classes.root}>
                <Table className={props.classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>uNID</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows}
                    </TableBody>
                </Table>
                {renderDepartmentModal()}
            </Paper>
        )
    }

};

CanvasUserTable.propTypes = {
    users: PropTypes.arrayOf(
        PropTypes.shape({
            unid: PropTypes.string.isRequired,
            display_name: PropTypes.string.isRequired
        }).isRequired
    ),
    onUserSelection: PropTypes.func.isRequired,
    hideRemove: PropTypes.bool
};

export default withStyles(styles)(CanvasUserTable);